import React, { useState } from 'react';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import ConnectTikTok from './pages/ConnectTikTok';
import TikTokCallback from './pages/TikTokCallback';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Upload from './components/Upload';
import Schedule from './components/Schedule';
import Queue from './components/Queue';
import Analytics from './components/Analytics';

function AppInner() {
  const { user, loading } = useAuth();
  const [authMode, setAuthMode] = useState(null); // null | 'login' | 'register'
  const [page, setPage] = useState('dashboard');

  // TikTok OAuth proxy callback — login gerektirmez
  if (window.location.pathname === '/tiktok/callback') {
    return <TikTokCallback />;
  }

  if (loading) return <LoadingScreen />;

  // Giriş yapılmamış
  if (!user) {
    if (authMode) {
      return <AuthPage mode={authMode} onBack={() => setAuthMode(null)} />;
    }
    return <LandingPage onAuth={setAuthMode} />;
  }

  // Giriş yapılmış — uygulama
  const renderPage = () => {
    switch (page) {
      case 'dashboard': return <Dashboard onNavigate={setPage} />;
      case 'upload':    return <Upload onNavigate={setPage} />;
      case 'schedule':  return <Schedule onNavigate={setPage} />;
      case 'queue':     return <Queue onNavigate={setPage} />;
      case 'analytics': return <Analytics />;
      case 'tiktok':    return <ConnectTikTok />;
      default:          return <Dashboard onNavigate={setPage} />;
    }
  };

  return (
    <div className="app">
      <Sidebar active={page} onNavigate={setPage} />
      {renderPage()}
    </div>
  );
}

function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-primary)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12, margin: '0 auto 16px',
          background: 'linear-gradient(135deg, var(--accent), var(--pink))',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}>
          <span style={{ fontSize: 20 }}>⚡</span>
        </div>
        <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Loading...</p>
      </div>
      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }`}</style>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
